import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import plusIcon from '../../assets/img/icons/plus_white.svg';
import CreateProjectDropdown from '../../components/DropdownStyle/CreateProjectDropdown';
import Select from '../../components/ReactSelectDropdown';
import { filterOption } from '../../components/ReactSelectDropdown/ReactSelectDropdown';
import {
  ButtonIcon,
  ColoredButtonWithIcon,
} from '../../styledComponents/buttons';
import {
  FilterLabel,
  HeaderContainer,
  InputField,
  InputWithLabelSection,
  PageTitle,
} from '../../styledComponents/common';
import { CommonGrid } from '../../styledComponents/common';
import AddLocationModal from '../Tasks/CreateTask/AddLocationModal';
import DeleteTaskLocationModal from './DeleteTaskLocationModal';
import EditTaskLocationModal from './EditTaskLocationModal';
import StaticTaskLocationModal from './StaticTaskLocationModal';
import TaskLocationsTable from './TaskLocationsTable';

const TaskLocations = ({
  getTaskLocation,
  addTaskLocation,
  editTaskLocation,
  deleteTaskLocation,

  locationListIsLoading,
  addTaskLocationLoading,
  editTaskLocationLoading,
  deleteTaskLocationLoading,
  locationsList,
  createdTaskLocationInfo,

  getOfficesShortList,
  officesShortList,
}) => {
  const { t } = useTranslation();
  const [taskLocations, setTaskLocations] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [addLocationModalOpen, setAddLocationModalOpen] = useState(false);
  const [editLocationModalOpen, setEditLocationModalOpen] = useState(false);
  const [deleteLocationModalOpen, setDeleteLocationModalOpen] = useState(false);
  const [seeLocationModalOpen, setSeeLocationModalOpen] = useState(false);
  const [selectedTaskLocation, setSelectedTaskLocation] = useState(null);
  const [selectedOffice, setSelectedOffice] = useState(null);
  const [selectedRegion, setSelectedRegion] = useState(null);
  const [officeOptions, setOfficeOptions] = useState([]);
  const [regionOptions, setRegionOptions] = useState([
    { label: t('all_regions'), value: null },
    { label: t('mina'), value: 'mina' },
    { label: t('arafat'), value: 'arafat' },
  ]);
  useEffect(() => {
    setSelectedOffice({
      label: t('all_offices'),
      value: null,
    });
    getOfficesShortList();
  }, []);
  useEffect(() => {
    if (officesShortList && officesShortList.length > 0) {
      let newArr = [
        {
          label: t('all_offices'),
          value: null,
        },
      ];
      officesShortList.forEach((office, i) => {
        newArr.push({
          label: office.name,
          value: office.id,
        });
      });
      setOfficeOptions(newArr);
    }
  }, [officesShortList]);

  useEffect(() => {
    if (locationsList && locationsList.length > 0) {
      setTaskLocations(locationsList);
    } else if (locationsList && locationsList.length === 0) {
      setTaskLocations([]);
    }
  }, [locationsList]);

  useEffect(() => {
    if (
      searchTerm &&
      searchTerm !== '' &&
      locationsList &&
      locationsList.length > 0
    ) {
      const originalList = JSON.parse(JSON.stringify(locationsList));
      const filteredList = [];
      originalList.forEach(e => {
        if (
          searchTerm &&
          e.name.toLowerCase().indexOf(searchTerm.toLowerCase().trim()) === -1
        ) {
          return;
        }
        filteredList.push(e);
      });
      setTaskLocations(filteredList);
    } else if (searchTerm === '') {
      setTaskLocations(locationsList);
    }
  }, [searchTerm]);

  const onSearchTermChange = e => {
    const { value } = e.target;
    setSearchTerm(value);
  };
  const selectOffice = e => {
    setSearchTerm('');
    setSelectedOffice(e);
  };

  const selectRegion = e => {
    setSearchTerm('');
    setSelectedRegion(e);
  };
  const handleShowLocation = location => {
    setSelectedTaskLocation(location);

    setTimeout(() => {
      setSeeLocationModalOpen(true);
    }, 300);
  };

  const handleEditLocation = location => {
    setSelectedTaskLocation(location);

    setTimeout(() => {
      setEditLocationModalOpen(true);
    }, 300);
  };
  const handleDeleteLocation = location => {
    setSelectedTaskLocation(location);
    setDeleteLocationModalOpen(true);
  };
  const confirmDeleteLocation = locationId => {
    deleteTaskLocation({
      location_id: locationId,
      selectedOffice,
      selectedRegion,
      searchTerm,
    });
    setDeleteLocationModalOpen(false);
  };

  useEffect(() => {
    const payload = {};
    if (selectedOffice && selectedOffice.value) {
      payload.office_id = selectedOffice.value;
    }
    if (selectedRegion && selectedRegion.value) {
      payload.region = selectedRegion.value;
    }
    if (searchTerm && searchTerm !== '') {
      payload.name = searchTerm;
    }
    getTaskLocation(payload);
  }, [selectedOffice, selectedRegion, searchTerm, createdTaskLocationInfo]);

  return (
    <div className="content">
      <PageTitle>{t('office_locations')}</PageTitle>
      <HeaderContainer
        columns={
          localStorage.getItem('user_role') === 'admin'
            ? '500px auto'
            : '250px auto'
        }
      >
        {' '}
        <CommonGrid
          columns="250px 250px 250px"
          gap="20px"
          justifyContent="flex-start"
        >
          <InputWithLabelSection>
            <FilterLabel>{t('office')}</FilterLabel>

            <Select
              isSearchable
              value={selectedOffice}
              options={officeOptions}
              placeholder={t('select_office')}
              onChange={e => {
                selectOffice(e);
              }}
              styles={CreateProjectDropdown()}
              filterOption={filterOption}
            />
          </InputWithLabelSection>
          <InputWithLabelSection>
            <FilterLabel>{t('search_location')}</FilterLabel>
            <InputField
              type="text"
              placeholder={t('search_by_location_name')}
              value={searchTerm}
              onChange={e => onSearchTermChange(e)}
            />
          </InputWithLabelSection>
          <InputWithLabelSection>
            <FilterLabel>{t('region')}</FilterLabel>

            <Select
              isSearchable
              value={selectedRegion}
              options={regionOptions}
              placeholder={t('select_region')}
              onChange={e => {
                selectRegion(e);
              }}
              styles={CreateProjectDropdown()}
              filterOption={filterOption}
            />
          </InputWithLabelSection>
        </CommonGrid>
        <ColoredButtonWithIcon onClick={() => setAddLocationModalOpen(true)}>
          <ButtonIcon src={plusIcon} alt="" />
          {t('add_new_location')}
        </ColoredButtonWithIcon>
      </HeaderContainer>{' '}
      <AddLocationModal
        isOpen={addLocationModalOpen}
        toggle={() => setAddLocationModalOpen(false)}
        addTaskLocation={addTaskLocation}
        addTaskLocationLoading={addTaskLocationLoading}
        createdTaskLocationInfo={createdTaskLocationInfo}
        getOfficesShortList={getOfficesShortList}
        officesShortList={officesShortList}
      />{' '}
      <StaticTaskLocationModal
        isOpen={seeLocationModalOpen}
        toggle={() => {
          setSeeLocationModalOpen(false);
          setSelectedTaskLocation(null);
        }}
        taskLocation={selectedTaskLocation}
      />{' '}
      <EditTaskLocationModal
        isOpen={editLocationModalOpen}
        toggle={() => {
          setEditLocationModalOpen(false);
          setSelectedTaskLocation(null);
        }}
        editTaskLocation={editTaskLocation}
        editTaskLocationLoading={editTaskLocationLoading}
        getOfficesShortList={getOfficesShortList}
        officesShortList={officesShortList}
        taskLocation={selectedTaskLocation}
        selectedFilterOffice={selectedOffice}
        selectedFilterRegion={selectedRegion}
        searchTerm={searchTerm}
      />
      <DeleteTaskLocationModal
        isOpen={deleteLocationModalOpen}
        toggle={() => {
          setDeleteLocationModalOpen(false);
          setSelectedTaskLocation(null);
        }}
        handleDelete={confirmDeleteLocation}
        id={selectedTaskLocation?.id}
        isLoading={deleteTaskLocationLoading}
      />
      <TaskLocationsTable
        locationsList={taskLocations}
        isLoading={locationListIsLoading}
        handleShowLocation={handleShowLocation}
        handleEditLocation={handleEditLocation}
        handleDeleteLocation={handleDeleteLocation}
      />
    </div>
  );
};

export default TaskLocations;
